import { RolesMap } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'
import VendorModule from './VendorModule.vue'
import ListVendors from './views/ListVendors.vue'
import CreateVendor from './views/CreateVendor.vue'
import ShowVendor from './views/ShowVendor.vue'
import EditVendor from './views/EditVendor.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/vendors',
    component: VendorModule,
    meta: { authorize: [RolesMap.EMPLOYEE_ROLE] },
    children: [
      {
        path: '',
        name: 'ListVendors',
        component: ListVendors,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: 'new',
        name: 'CreateVendor',
        component: CreateVendor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id',
        name: 'ShowVendor',
        component: ShowVendor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      },
      {
        path: ':id/edit',
        name: 'EditVendor',
        component: EditVendor,
        meta: { authorize: [RolesMap.EMPLOYEE_ROLE] }
      }
    ]
  }
]

export default routes
